import React from "react";
import { ReactComponent as arrow1 } from "../icons/arrow1.svg";
import { ReactComponent as arrow2 } from "../icons/arrow2.svg";

const ArrowShape = ({
  type = "arrow2",           // Choose which arrow to use
  color = "currentColor",
  size = 50,
  speed = "3s",              // Animation speed
  className = "",
  ...props
}) => {
  const Arrow = type === "arrow2" ? arrow1 : arrow2;

  return (
    <span
      className={`animated-arrow ${className}`}
      style={{
        display: "inline-block",
        width: size,
        height: size,
        color,
        "--arrow-speed": speed, // Pass speed as CSS variable
      }}
      aria-hidden="true"
    >
      <Arrow {...props} />
    </span>
  );
};

export default ArrowShape;
